/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { UserSearchesType } from '../enums/user-searches-type';
export class UserSearchEntity extends Entity {
  alertActive: boolean = false;
  createdAt: string | null = null;
  id: string = '';
  name: string | null = null;
  search: Record<string, unknown> | null = null;
  type: UserSearchesType | null = null;
  updatedAt: string | null = null;
  userId: string | null = null;
  static override key = 'UserSearch';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'UserSearch' in input
    ) {
      const { UserSearch: wrapped, ...rest } = input as {
        UserSearch: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}